import { render, staticRenderFns } from "./baseTemplate.vue?vue&type=template&id=07f1f6d6&scoped=true&"
import script from "./baseTemplate.vue?vue&type=script&lang=js&"
export * from "./baseTemplate.vue?vue&type=script&lang=js&"
import style0 from "./baseTemplate.vue?vue&type=style&index=0&id=07f1f6d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f1f6d6",
  null
  
)

export default component.exports